import axios from 'axios';
import { getUgcData } from '@fiverr-private/gig_listings/src/GigCardListings/externalUtils/getUgcData';
import { raiseErrorToast } from '@fiverr-private/machine_translation';
import { setCookie } from '../../utils/cookies';
import {
    TRANSLATE_UGC_COOKIE_NAME,
    TRANSLATE_UGC_COOKIE_DOMAIN,
    TRANSLATE_UGC_COOKIE_EXPIRATION_DAYS
} from '../../utils/constants';
import ACTION_TYPES from '../../components/context/actionTypes';
import { HttpStatusCode } from '../../../../shared/types/httpStatusCode';

const { logger } = require('@fiverr-private/perseus');

const _setCookie = (value) => {
    setCookie({ name: TRANSLATE_UGC_COOKIE_NAME, value, expirationDays: TRANSLATE_UGC_COOKIE_EXPIRATION_DAYS, domain: TRANSLATE_UGC_COOKIE_DOMAIN });
};

const _dataTranslationSucceeded = (status) => {
    if (status !== HttpStatusCode.OK) {
        raiseErrorToast();
        logger.warn(`Failed to translate UGC. Error code: ${status}`);
    }

    return status === HttpStatusCode.OK;
};

export const onTranslateBtnClick = async function(gigsListings, appContext, hidePrefix) {
    const { showTranslatedUGC,
        wasTranslatedBefore,
        listings,
        sourceInfo,
        locale,
        knownCrawler,
        dispatch } = appContext;

    if (!wasTranslatedBefore) {
        const flatGigsListings = getUgcData(gigsListings.flat(), locale, hidePrefix);

        dispatch({ type: ACTION_TYPES.TOGGLE_LOADING, loading: true });
        const fetchTranslationData = await axios.post('/v4/search/fetch_translated_ugc', { gigsListings: flatGigsListings, sourceInfo, knownCrawler });
        dispatch({ type: ACTION_TYPES.TOGGLE_LOADING, loading: false });

        const translatedGigsListings = gigsListings.map((gigs) => (gigs.map((gig) => ({ ...gig, ...fetchTranslationData.data.translatedBlob[gig.gig_id] }))));
        const ugcListings = listings.map((listing, index) => listing = ({ ...listing, gigs: translatedGigsListings[index], showTranslatedUGC: true }));
        const translatonSucceeded = _dataTranslationSucceeded(fetchTranslationData.data.translationStatus, locale);
        _setCookie(true);
        const payload = { listings: ugcListings, showTranslatedUGC: translatonSucceeded, wasTranslatedBefore: translatonSucceeded };
        dispatch({ type: ACTION_TYPES.GIGS_TRANSLATED, payload });
    }
    else {
        const toggledValue = !showTranslatedUGC;
        const ugcListings = listings.map((listing) => ({ ...listing, showTranslatedUGC: toggledValue }));
        _setCookie(toggledValue);
        const payload = { listings: ugcListings, showTranslatedUGC: toggledValue };
        dispatch({ type: ACTION_TYPES.GIGS_TRANSLATED, payload });
    }
};

export const fetchUgcContent = async function(listings, sourceInfo, knownCrawler) {
    const listingsCopy = Array.from(listings);
    const gigsListings = listingsCopy[0].gigs;
    const flatGigsListings = getUgcData(gigsListings.flat(), this.props.appContext.locale);
    const fetchTranslationData = await axios.post('/v4/search/fetch_translated_ugc', { gigsListings: flatGigsListings, sourceInfo, knownCrawler });
    const translatedGigsListings = gigsListings.map((gig) => ({ ...gig, ...fetchTranslationData.data.translatedBlob[gig.gig_id] }));

    listingsCopy[0] = { ...listingsCopy[0], gigs: translatedGigsListings, showTranslatedUGC: true };

    !fetchTranslationData.data.failedToTranslate && this.setState({ listings: listingsCopy });
};
